export const CCourseTypes = {
  CLASS: "class",
  COURSE: "course",
  WORKSHOP: "workshop"
};
